export const DECREMENT_ACTIVE_OPTION_INDEX = 'DECREMENT_ACTIVE_OPTION_INDEX';
export const INCREMENT_ACTIVE_OPTION_INDEX = 'INCREMENT_ACTIVE_OPTION_INDEX';
export const SELECT_ACTIVE_OPTION = 'SELECT_ACTIVE_OPTION';
export const SET_ACTIVE_OPTION_INDEX = 'SET_ACTIVE_OPTION_INDEX';
export const SET_INPUT_VALUE = 'SET_INPUT_VALUE';
export const SET_IS_DISABLED = 'SET_IS_DISABLED';
export const SET_IS_INVALID = 'SET_IS_INVALID';
export const SET_IS_OPEN = 'SET_IS_OPEN';
export const SET_IS_REQUIRED = 'SET_IS_REQUIRED';
export const SET_OPTIONS = 'SET_OPTIONS';
export const SET_SELECTED_VALUE = 'SET_SELECTED_VALUE';
export const DISPLAY_NAME_COMBOBOX = 'Combobox';
export const DISPLAY_NAME_ERROR = 'Error';
export const DISPLAY_NAME_FIELD = 'Field';
export const DISPLAY_NAME_INPUT = 'Input';
export const DISPLAY_NAME_LABEL = 'Label';
export const DISPLAY_NAME_OPTION = 'Option';
export const DISPLAY_NAME_OPTIONS = 'Options';
export const DISPLAY_NAME_WRAPPER = 'Wrapper';
export const SET_IS_NAVIGATING_WITH_KEYBOARD = 'SET_IS_NAVIGATING_WITH_KEYBOARD';
//# sourceMappingURL=constants.js.map